"use strict";

exports.__esModule = true;
exports.getRandomArrayItem = getRandomArrayItem;

function getRandomArrayItem(array) {
  const r = Math.floor(Math.random() * Math.floor(array.length));
  return array[r];
}